import { User } from "@kazoohr/types";

export default function usersMatch(user1: User, user2: User | string): boolean {
  const id = typeof user2 === "string" ? user2 : user2.id;
  if (user1.id === id || user1.ids.kazooId === id || user1.ids.rrId === id) {
    return true;
  }
  return false;
}
